import Icon from '../../@shared/icon';
import React from 'react';
import { iconSize } from '../../../constants/icon.constants';

const MenuTriggerContentWithIcon = ({ iconField, textValue }) => {
  return (
    <span className="navigation__menu-item__trigger__content navigation__menu-item__trigger__content--with-icon">
      <Icon iconField={iconField} size={iconSize.dsk} extraClassName="navigation__menu-item__trigger__icon" color="primary" />
      <span className="navigation__menu-item__trigger__text">{textValue}</span>
    </span>
  );
};

export default MenuTriggerContentWithIcon;
